import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import MainPage from './components/MainPage';

function RoutesFile() {
  const [activeSection, setActiveSection] = useState("Buy IHKAAS");

  return (
    <Router>
      <Navbar setActiveSection={setActiveSection} /> {/* Pass setter to Navbar */}
      <Routes>
        <Route path="/" element={<MainPage activeSection={activeSection} />} /> {/* Pass state to MainPage */}
      </Routes>
    </Router>
  );
}

export default RoutesFile;
